export const smoothScroll =
  (target, offset = 0) =>
  (e) => {
    e.preventDefault();
    if (!target) return;

    const top =
      target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({
      behavior: "smooth",
      top: top,
    });
  };

export const smoothScrollToTop = (selector = ".js-scroll-top") => {
  const btns = document.querySelectorAll(selector);
  btns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      smoothScroll(document.body)(e);
    });
  });
};

export const initSmoothScroll = (
  selector = 'a[href^="#"]',
  defaultOffset = 0
) => {
  const anchors = document.querySelectorAll(selector);

  anchors.forEach((a) => {
    a.addEventListener("click", (e) => {
      const href = a.getAttribute("href") || "";
      // 空ハッシュや「#」単体は無視
      if (!href || href === "#") return;
      // 同一ページ内ハッシュのみ対象
      if (!href.startsWith("#")) return;

      const id = href.slice(1);
      const target = id ? document.getElementById(id) : null;
      if (!target) return;

      // 個別オフセット（data-offset）優先
      const raw = a.dataset.offset;
      const offset = Number.isFinite(Number(raw)) ? Number(raw) : defaultOffset;

      smoothScroll(target, offset)(e);

      // 履歴のハッシュを更新
      history.pushState(null, "", href);
    });
  });
};
